module.exports = __webpack_public_path__ + "img/流体力学3_5.faa676a0.jpg";